import React, { useState } from "react";
import "./UploadPodcastPage.css";
import { Formik, Field, Form } from "formik";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";

const FORM_DATA = gql`
  query FormData {
    sports {
      id
      name
    }

    allPodcastSeries {
      id
      title
    }
  }
`;

const UPLOAD_PODCAST = gql`
  mutation UploadPodcast(
    $title: String!
    $description: String!
    $file: Upload!
    $sportID: ID!
    $seriesID: ID!
    $explicit: Boolean!
  ) {
    createPodcast(
      title: $title
      description: $description
      seriesId: $seriesID
      sportId: $sportID
      file: $file
      explicit: $explicit
    ) {
      podcast {
        title
      }
    }
  }
`;

export default function UploadPodcastPage() {
  const [file, setFile] = useState(undefined);
  const [formLoading, setFormLoading] = useState(false);
  const [uploadPodcast] = useMutation(UPLOAD_PODCAST);
  const { loading, error, data } = useQuery(FORM_DATA);
  const history = useHistory();

  if (loading) return <></>;
  if (error) return <>Something went wrong.</>;

  function handleUpload(title, description, seriesId, sportId, explicit) {
    setFormLoading(true);

    // Prod bug where explicit is coming through as a blank string
    if (explicit === "") {
      explicit = false;
    }

    uploadPodcast({
      variables: {
        title: title,
        description: description,
        file: file,
        seriesID: seriesId,
        sportID: sportId,
        explicit: explicit,
      },
    })
      .then(() => {
        setFormLoading(false);
        history.push("/podcasts");
      })
      .catch(() => {
        setFormLoading(false);
        alert("Something went wrong.");
      });
  }

  return (
    <LoadingOverlay active={formLoading} spinner text="Uploading podcast...">
      <div className="upload-podcast-container">
        <h1>Upload Podcast</h1>
        <Formik
          initialValues={{
            title: "",
            description: "",
            series: data.allPodcastSeries[0].id,
            sport: data.sports[0].id,
            explicit: "",
          }}
          onSubmit={async (values) => {
            handleUpload(
              values.title,
              values.description,
              values.series,
              values.sport,
              values.explicit
            );
          }}
        >
          <Form>
            <label htmlFor="title">Title</label>
            <Field id="title" name="title" className="upload-podcast-title" />
            <br />
            <br />

            <label htmlFor="description">Description</label>
            <Field
              id="description"
              name="description"
              as="textarea"
              rows={10}
              cols={50}
            />

            <br />
            <br />

            <label htmlFor="sport">Sport</label>
            <Field id="sport" name="sport" as="select" defaultValue={0}>
              <option selected disabled value={0}>
                -- Select Sport --
              </option>
              {data.sports.map((sport) => {
                return (
                  <option value={sport.id} key={sport.id}>
                    {sport.name}
                  </option>
                );
              })}
            </Field>

            <br />
            <br />

            <label htmlFor="series">Series</label>
            <Field id="series" name="series" as="select">
              <option selected disabled>
                -- Select Series --
              </option>
              {data.allPodcastSeries.map((series) => {
                return (
                  <option value={series.id} key={series.id}>
                    {series.title}
                  </option>
                );
              })}
            </Field>

            <br />
            <br />

            <label htmlFor="file">Podcast MP3</label>
            <input
              id="file"
              name="file"
              type="file"
              onChange={(event) => {
                event.preventDefault();
                setFile(event.currentTarget.files[0]);
              }}
            />

            <br />
            <br />

            <label htmlFor="checkbox">Explicit?</label>
            <Field type="checkbox" name="explicit" />

            <br />
            <br />

            <button type="submit">Submit</button>
          </Form>
        </Formik>
      </div>
    </LoadingOverlay>
  );
}
